var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "new-page-base",
    {
      attrs: {
        loading:
          _vm.loadingBillingTemplatePreview || _vm.loadingBillingTemplates,
        showBackText: "Faturas"
      },
      on: { back: _vm.goBack }
    },
    [
      _c("template", { attrs: { slot: "titleLeft" }, slot: "titleLeft" }, [
        _vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")
      ]),
      _vm._v(" "),
      !_vm.isViewMode
        ? _c("span", [
            _c("p", { staticClass: "header-message" }, [
              _vm._v(
                "Adicione um novo modelo de fatura e identifique os valores divergentes da fatura de uma nova transportadora."
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "header-message" }, [
              _vm._v("Se tiver dificuldade em criar um novo modelo,\n      "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://esprinter.atlassian.net/servicedesk/customer/portal/9/group/36/create/162",
                    target: "_blank"
                  }
                },
                [_vm._v("\n        fale com nosso suporte\n      ")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-content" },
        [
          _vm.isViewMode
            ? _c("billing-template-view-mode", {
                attrs: { "template-id": _vm.$route.query.view }
              })
            : _c("new-billing-template-wizard")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-modal" },
        [
          _c("sc-confirmation-modal", {
            attrs: {
              "is-active": _vm.isExitModalActive,
              type: "primary",
              title: "Sair sem salvar?",
              cancelText: "Fechar",
              "confirm-text": "Sair mesmo assim",
              messages: [
                "Ao sair da criação de modelo de fatura, as alterações feitas não serão salvas.",
                "Tem certeza que deseja sair?"
              ]
            },
            on: {
              "update:isActive": function($event) {
                _vm.isExitModalActive = $event
              },
              onConfirm: function() {
                return this$1.$router.push({ name: "billing-main-page" })
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c29160e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c29160e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/PageBillingTemplates.vue
// module id = null
// module chunks = 